import type { PlayerId } from "@cloudnest/warchest-engine";
import type { HistoryEntry } from "../multiplayer-game-store";

const EVENT_LABEL: Record<string, string> = {
  init: "게임 시작",
  draw_phase: "뽑기 단계",
  deploy: "배치",
  bolster: "강화",
  move: "이동",
  attack: "공격",
  control: "점령",
  recruit: "모집",
  pass: "패스",
  claim_initiative: "선공권 획득",
  tactic: "전술",
};

function inferPlayer(
  eventType: string,
  payload: Record<string, unknown>,
): PlayerId | null {
  if (eventType === "init" || eventType === "draw_phase") return null;
  const player = payload.player;
  if (player === "P1" || player === "P2") return player;
  return null;
}

export function WarchestHistoryPanel({
  events,
}: {
  events: readonly HistoryEntry[];
}) {
  return (
    <details
      data-testid="warchest-history"
      className="rounded-lg border"
      style={{
        background: "var(--cn-warchest-card-bg)",
        borderColor: "var(--cn-warchest-card-border)",
      }}
    >
      <summary
        className="cursor-pointer select-none rounded-lg px-3 py-2 font-medium text-sm"
        style={{ color: "var(--cn-warchest-text-muted)" }}
      >
        기록 ({events.length})
      </summary>
      <ol className="space-y-0.5 px-3 pt-1 pb-3 text-xs">
        {events.map((entry) => {
          const player = inferPlayer(entry.eventType, entry.payload);
          return (
            <li
              key={entry.sequenceNumber}
              data-testid={`warchest-history-entry-${entry.sequenceNumber}`}
              data-event-type={entry.eventType}
              data-player={player ?? undefined}
              className="flex items-center gap-2 font-mono"
              style={{ color: "var(--cn-warchest-text)" }}
            >
              <span style={{ color: "var(--cn-warchest-text-muted)" }}>
                #{entry.sequenceNumber}
              </span>
              <span className="font-semibold">
                {EVENT_LABEL[entry.eventType] ?? entry.eventType}
              </span>
              {player && (
                <span style={{ color: "var(--cn-warchest-text-muted)" }}>
                  ({player})
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </details>
  );
}
